import { useSelector } from 'react-redux';
import { userSelectors } from '../redux/modules/user';

export const useActiveUserId = (): string =>
  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  useSelector(userSelectors.selectActiveUserId);

export default useActiveUserId;
